export default __webpack_public_path__ + "static/media/bg-desktop.0ecbed38.jpg";